// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminEventResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type AdminEventApiResponse = {
	id: number;
	status: string;
	event: string;
	message: string | null;
	duration: number | null;
	startConsumeDate: string | null;
	createdAt: string | null;
	consumer: string | null;
	origin: number | null;
	error: string | null;
	errorTrace: string | null;
	business: string | null;
	businessName: string | null;
	processedBy: string | null;
};

export type AdminEvent = {
	id: number;
	status: string;
	event: string;
	message: string | null;
	duration: number | null;
	startConsumeDate: DateTime | null;
	createdAt: DateTime | null;
	consumer: string | null;
	origin: number | null;
	error: string | null;
	errorTrace: string | null;
	business: string | null;
	businessName: string | null;
	processedBy: string | null;
};

export function hydrateAdminEvent(data: AdminEventApiResponse): AdminEvent {
	return {
		...data,
		startConsumeDate: DateTimefromISO(data.startConsumeDate),
		createdAt: DateTimefromISO(data.createdAt),
	};
}